import Immutable from "immutable";

const SecureTrading = new Immutable.Record({
  status: undefined,
  message: undefined,
  code: undefined,
  threeds_status: undefined,
  threeds_enrolled: undefined,
  threeds_acsurl: undefined,
  threeds_pareq: undefined,
  threeds_termurl: undefined,
  threeds_md: undefined,
  card_holder_name: undefined,
  payment_request_jwt_string: undefined,
  error_code: undefined,
  error_message: undefined,
  payment_response_jwt_string: undefined,
  wallet_pay_jwt_string: undefined
}, "SecureTrading");

function buildSecureTradingFromAppserver(rawSecureTrading) {
  return SecureTrading({
    status: rawSecureTrading.status,
    message: rawSecureTrading.message,
    code: rawSecureTrading.code,
    threeds_status: rawSecureTrading.threeds_status,
    threeds_enrolled: rawSecureTrading.threeds_enrolled,
    threeds_acsurl: rawSecureTrading.threeds_acsurl,
    threeds_pareq: rawSecureTrading.threeds_pareq,
    threeds_termurl: rawSecureTrading.threeds_termurl,
    threeds_md: rawSecureTrading.threeds_md
  });
}

SecureTrading.fromAppserver = buildSecureTradingFromAppserver;
export default SecureTrading;



// WEBPACK FOOTER //
// ./src/state/school_money/entities/SecureTrading.js